import type { ScriptTabDef } from './ScriptLibrary';

export const INTERVENTION_SCRIPT_TABS: ScriptTabDef[] = [
  {
    key: 'initial',
    label: 'Initial Intervention',
    alert: {
      type: 'error',
      message:
        'Use when: payment issues, repeated support volume, competitor mentions, or sentiment drop. Stay calm, factual, and solution-oriented.',
    },
    blocks: [
      {
        phase: 'OPEN',
        title: 'Acknowledge & set tone',
        lines: [
          {
            speaker: 'Rep',
            text:
              'Hi [NAME], this is [YOUR NAME] from [COMPANY]. I am reaching out because I noticed [TRIGGER — e.g. a few open tickets / a billing question / feedback you left]. I want to make sure we address this directly with you. Do you have a few minutes?',
          },
        ],
      },
      {
        phase: 'DISCOVERY',
        title: 'Understand root cause',
        lines: [
          {
            speaker: 'Rep',
            text:
              'Help me understand what happened from your perspective — what impact did this have on your business day-to-day?',
          },
        ],
      },
    ],
  },
  {
    key: 'complaint',
    label: 'Complaint Resolution',
    alert: {
      type: 'warning',
      message:
        'Use when: formal complaint, negative review, chargeback escalation, or billing discrepancy. Acknowledge impact before explaining.',
    },
    blocks: [
      {
        phase: 'SERVICE RECOVERY',
        title: 'Opening — acknowledge before explaining',
        lines: [
          {
            speaker: 'Rep',
            text:
              'Hi [NAME], this is [YOUR NAME], I am the Customer Success Manager at [COMPANY]. I am calling specifically about [ISSUE TYPE]. First — I want to sincerely apologize that you experienced this. The impact on your business is what matters, and I am sorry.',
          },
        ],
      },
      {
        phase: 'INVESTIGATE',
        title: 'Fact-finding',
        lines: [
          {
            speaker: 'Rep',
            text:
              'I have reviewed what I have on my side, but I want the full picture from you. Can you walk me through exactly what happened — what you experienced and when?',
          },
        ],
      },
    ],
  },
  {
    key: 'save',
    label: 'Save Call',
    alert: {
      type: 'error',
      message:
        'Use when: cancellation request or intent to switch. Never make offers you cannot honor; offer value, not pressure.',
    },
    blocks: [
      {
        phase: 'SAVE',
        title: 'Direct, confident opening',
        lines: [
          {
            speaker: 'Rep',
            text:
              'Hi [NAME], this is [YOUR NAME], the Customer Success Manager at [COMPANY]. I understand you are looking to cancel your account, and I wanted to call you personally before anything moves forward. I am not going to pressure you — I want a few minutes to understand what drove you to this point and see if there is anything I can do. Is that okay?',
          },
        ],
      },
    ],
  },
  {
    key: 'winback',
    label: 'Win-Back',
    blocks: [
      {
        phase: 'OPEN',
        title: 'Leave the door open',
        lines: [
          {
            speaker: 'Rep',
            text:
              'I know you have moved on from our platform. I am calling to see how that transition went for you — and if there is anything we could have done differently. If your situation changes, we would welcome the chance to earn your business again.',
          },
        ],
      },
    ],
  },
];
